import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=bbcf4082&"
import script from "./Competitor.vue?vue&type=script&lang=js&"
export * from "./Competitor.vue?vue&type=script&lang=js&"
import style0 from "./Competitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports